import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../../httpClient/serverApi/types/IResponse';
import { ISingleIdParams } from '../../../../spacesPlatform/utils/actionParams';

// NOTE: This request violates the standard contract;
// rather than returning an IResult, it returns a boolean.
// The existing uses check the "truthiness" of the result.
// The API should be changed to adhere to the standard contract.
export class TestOAuthCredentialRequest extends Request<ISingleIdParams, IResult> {
  constructor(id: string) {
    super('testOAuthCredential', { id: id });
  }
}
